const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimestroke(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,389.702,-390.097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.097,6.434L483.076,92.393L397.118,92.393L440.097,6.434Z",
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "8.96px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3.99745,2.13163e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.823,7.021L91.823,92.979L34.224,92.979C22.364,92.979 12.735,83.35 12.735,71.49L12.735,28.51C12.735,16.65 22.364,7.021 34.224,7.021L91.823,7.021Z",
    style: {
      stroke: "black",
      strokeWidth: "8.96px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-37.9266,3.55271e-15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.247,7.021L238.773,50L171.247,92.979L148.794,92.979L148.794,7.021L171.247,7.021Z",
    style: {
      stroke: "black",
      strokeWidth: "8.96px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-37.9266,3.55271e-15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.228,50L297.755,7.021L320.208,7.021L320.208,92.979L297.755,92.979L230.228,50Z",
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "8.96px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimestroke);
export default __webpack_public_path__ + "static/media/Timestroke.45854bd1f9f0d4a16c906fe76505e8af.svg";
export { ForwardRef as ReactComponent };